/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchReservations = makeAsyncReducer(types.FETCH_RESERVATIONS);

const reservations = mergeReducers(asyncDefaults([]), types.PREFIX, fetchReservations);

export default reservations;
